module.exports = __webpack_public_path__ + "static/media/selection-Mr_Morrison.8f2b1808.jpg";